<template>
	<IEcharts
		:option="bar"
		:loading="loading"
		:lazyUpdate="lazyUpdate"
		:resizable="resize"
	/>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
import { mapGetters } from "vuex";

export default {
    components: {
        IEcharts
    },
    props: {
        stepPoints: { default: 10 },
        //boundaryGap : {default: '[0,0.1]' },
        //splitNumber: {default: 500000},
        //interval: { default: 1000000 },
        showSelectorGBPUSD: {default:true},
        showSelectorUSDJPY: {default:true},
        showSelectorEURUSD:{default:true},
        showSelectorEURGBP:{default:true},
        showSelectorUSDCAD:{default:true},
        showSelectorUSDCHF:{default:true},
        update:{default: true},
        updateHight:{default:true},
        updateRight:{default:true},
        resize:{default:true}
    },
    data() {
        return {
            show:true,
            symbol:['EURUSD','GBPUSD','USDJPY','EURGBP','USDCAD','USDCHF'],
            loading: true,
            lazyUpdate: false,
            statistics: [],
            bar: {
                tooltip: {
                    show: true,
                    trigger: "axis",
                    axisPointer: {
                    type: "cross",
                    axis: "auto"
                    }
                },
                grid: [
                {
                    right: "68px",
                    top: "0",
                    width: "calc(100%-68px)",
                    height: "100%",
                    bottom:'0'
                }
                ],
                xAxis: {
                    show: false,
                    type: "category",
                    data: []
                },
                yAxis: {
                    position: "right",
                    type: "value",
                    //boundaryGap: this.boundaryGap,
                    //splitNumber: this.splitNumber,
                    //interval:this.interval,
                    scale:true,

                    axisLine: {
                        lineStyle: {
                            color: "#374b62"
                        },
                    },
                    axisTick: {
                        show: true,
                        alignWithLabel: true,
                    },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: "#718da8",
                        fontFamily: "Arimo",
                        width: "53px"
                    }
                },
                series: [
                    {
                        name: "EURUSD",
                        type: "line",
                        color: "#36e2ff",
                        showSymbol:false,
                        lineStyle: {
                            width: 2,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                        data: [],
                        markPoint: {
                            silent: true,
                            symbol: 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z',
                            symbolSize: [68, 19],
                            symbolRotate: '0',
                            symbolKeepAspect: false,
                            symbolOffset: ['50%', '0'],
                            label: {
                                show:true,
                                color:'#36e2ff',
                                fontFamily: 'Arimo'
                            },
                            data: [ {
                                value : 0,
                                xAxis: 0,
                                yAxis: 0
                                },
                            ]
                        }
                    },
                    {
                        name: "GBPUSD",
                        type: "line",
                        color: "#00ffd0",
                        showSymbol:false,
                        lineStyle: {
                            width: 2,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                        data: [],
                        markPoint: {
                            silent: true,
                            symbol: 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z',
                            symbolSize: [68, 19],
                            symbolRotate: '0',
                            symbolKeepAspect: false,
                            symbolOffset: ['50%', '0'],
                            label: {
                                show:true,
                                color:'#00ffd0',
                                position: ['12%', '20%'],
                            },
                            data: [ {
                                value : 0,
                                xAxis: 0,
                                yAxis: 0
                                },
                            ]
                        }
                    },
                    {
                        name: "USDJPY",
                        type: "line",
                        color: "#ff79e2",
                        showSymbol:false,
                        lineStyle: {
                            width: 2,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                        data: [],
                        markPoint: {
                            show:false,
                            data:[{
                                    xAxis:'2018-10-12T00:00:00',
                                    yAxis:3068360,
                                    silent: true,
                                    symbol: 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z',
                                    symbolSize: [68, 19],
                                    symbolRotate: '0',
                                    symbolKeepAspect: false,
                                    symbolOffset: ['50%', '0'],
                                    label: {
                                        show:true,
                                        color:'#ff79e2',
                                        position: ['12%', '20%'],
                                    }
                        }]
                        },
                    },
                    {
                        name: "EURGBP",
                        type: "line",
                        color: "#ffad66",
                        showSymbol:false,
                        lineStyle: {
                            width: 2,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                        data: [],
                        markPoint: {
                            show:false,
                            data:[{
                                    xAxis:'2018-10-12T00:00:00',
                                    yAxis:3068360,
                                    silent: true,
                                    symbol: 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z',
                                    symbolSize: [68, 19],
                                    symbolRotate: '0',
                                    symbolKeepAspect: false,
                                    symbolOffset: ['50%', '0'],
                                    label: {
                                        show:true,
                                        color:'#ffad66',
                                        position: ['12%', '20%'],
                                    }
                        }]
                        },
                    },
                    {
                        name: "USDCAD",
                        type: "line",
                        color: "#ecff24",
                        showSymbol:false,
                        lineStyle: {
                            width: 2,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                        data: [],
                        markPoint: {
                            show:false,
                            data:[{
                                    xAxis:'2018-10-12T00:00:00',
                                    yAxis:3068360,
                                    silent: true,
                                    symbol: 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z',
                                    symbolSize: [68, 19],
                                    symbolRotate: '0',
                                    symbolKeepAspect: false,
                                    symbolOffset: ['50%', '0'],
                                    label: {
                                        show:true,
                                        color:'#ecff24',
                                        position: ['12%', '20%'],
                                    }
                        }]
                        },
                    },
                    {
                        name: "USDCH",
                        type: "line",
                        color: "#a7aeff",
                        showSymbol:false,
                        lineStyle: {
                            width: 2,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                        data: [],
                        markPoint: {
                            show:false,
                            data:[{
                                    xAxis:'2018-10-12T00:00:00',
                                    yAxis:3068360,
                                    silent: true,
                                    symbol: 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z',
                                    symbolSize: [68, 19],
                                    symbolRotate: '0',
                                    symbolKeepAspect: false,
                                    symbolOffset: ['50%', '0'],
                                    label: {
                                        show:true,
                                        color:'#a7aeff',
                                        position: ['12%', '20%'],
                                    }
                        }]
                        },
                    }
                ]
            }
        };
    }, // data }
    computed: {
        ...mapGetters({
              getStatistics: 'accountstat/getStatistics'
        })
    },
    methods: {
        updateChart(symbol) {
            if (!symbol) symbol = this.symbol;
            let stat = []
            let equityByPairs = []
            for (let i = 0; i < symbol.length; i++)
            {
               stat.push(this.getStatistics(symbol[i]))
               equityByPairs.push({equity:this.getStatistics(symbol[i]).Summary.Equity, delta:((this.getStatistics(symbol[i]).Summary.Equity - this.getStatistics(symbol[i]).DailyRecords[this.getStatistics(symbol[i]).DailyRecords.length - 1].EquityOpen)/this.getStatistics(symbol[i]).Summary.Equity * 100)})
            }
            if (!stat) {
                //console.log(`updateChart(${symbol}): no points`);
                return;
            }
            this.statistics = stat;
            getPoints(this.statistics, this.bar, this.stepPoints,'');
            this.loading = false;
            this.$emit('onStatisticReady', equityByPairs)
        },
        updateChartbyPair(symbol, index)
        {
            if (!symbol) symbol = this.symbol;
            let stat = []
            for (let i = 0; i < symbol.length; i++)
            {
               stat.push(this.getStatistics(symbol[i]))
            }
            if (!stat) {
                //console.log(`updateChart(${symbol}): no points`);
                return;
            }
            this.statistics = stat;
            getPoints(this.statistics, this.bar, this.stepPoints, index);
        }
    }, //methods
    watch: {
        update: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateHight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateRight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        symbol: function(val) {
            this.$store.dispatch("accountstat/unsubscribeFromUpdate", this.symbol);
            if (!this.symbol || !this.symbol.length)
                return;
            subscribeOnUpdate(this.$store, val, isFirstObtained => {
                this.updateChart();
            });
            this.updateChart(val);
        },
        showSelectorGBPUSD: function() {
            if(this.showSelectorGBPUSD) {
                this.updateChartbyPair('',1);
                this.bar.series[1].markPoint.data[0].x = ''
            }

            else {
                this.bar.series[1].data = 0;
                this.bar.series[1].markPoint.data[0].x = '100%'
            }
        },
        showSelectorEURUSD: function() {
            if(this.showSelectorEURUSD ) {
                this.updateChartbyPair('',0);
                this.bar.series[0].markPoint.data[0].x = ''
            }
            else {
                this.bar.series[0].data = 0;
                this.bar.series[0].markPoint.data[0].x = '100%'
            }
        },
        showSelectorUSDJPY: function() {
            if(this.showSelectorUSDJPY)
            {
                this.updateChartbyPair('',2);
                this.bar.series[2].markPoint.data[0].x = ''
            }
            else {
                this.bar.series[2].data = 0;
                this.bar.series[2].markPoint.data[0].x = '100%'
             }
        },
        showSelectorEURGBP: function() {
            if(this.showSelectorEURGBP)
            {
                this.updateChartbyPair('',3);
                this.bar.series[3].markPoint.data[0].x = ''
            }
            else {
                this.bar.series[3].data = 0;
                this.bar.series[3].markPoint.data[0].x = '100%'
             }
        },
        showSelectorUSDCAD: function() {
            if(this.showSelectorUSDCAD)
            {
                this.updateChartbyPair('',4);
                this.bar.series[4].markPoint.data[0].x = ''
            }
            else {
                this.bar.series[4].data = 0;
                this.bar.series[4].markPoint.data[0].x = '100%'
             }
        },
        showSelectorUSDCHF: function() {
            if(this.showSelectorUSDCHF)
            {
                this.updateChartbyPair('',5);
                this.bar.series[5].markPoint.data[0].x = ''
            }
            else {
                this.bar.series[5].data = 0;
                this.bar.series[5].markPoint.data[0].x = '100%'
             }
        },

    }, //watch
    // hooks
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            if (!this.symbol || !this.symbol.length) {
                this.updateChart(this.symbol);
            }
        });
        // может быть, данные уже есть в store
        this.updateChart(this.symbol);
    } // created }
}

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: `profit-chart-compare-${symbol}`,
            handler: handler
        }
    });
}

function getMaxMinPoints(firstPoint, lastPoint)
{
    let countFirstPoint = firstPoint.toFixed().toString().length
    let countLastPoint = lastPoint.toFixed().toString().length
    let points = {
        first: 0,
        last: 0
    }
    points.first = (firstPoint.toFixed() / Math.pow(10,countFirstPoint - 1)).toFixed(1) * (Math.pow(10,countFirstPoint - 1))
    points.last = Math.ceil(lastPoint.toFixed() / Math.pow(10,countLastPoint - 1)) * Math.pow(10,countLastPoint - 1)
    return points
}
function getPointForOnePair(pointArray, statArray, indexPair, step)
{
    for(let i = 0; i < statArray[indexPair].DailyRecords.length; i += step)
    pointArray.push(statArray[indexPair].DailyRecords[i].EquityClose)
    pointArray.push(statArray[indexPair].DailyRecords[statArray[indexPair].DailyRecords.length - 1].EquityClose);

}

function getPoints(statistics, chartObject, stepPoints, indexPair) {
    if(indexPair === '') {
    let points = {
        equity: { eurusd:[], gbpusd:[], usdjpy:[], eurgbp:[], usdcad:[], usdchf:[] },
        markPoint: { eurusd:0, gbpusd:0, usdjpy:0, eurgbp:0, usdcad:0, usdchf:0 },
        markPointEURUSD: 0,
        markPointGBPUSD: 0,
        markPointUSDJPY:0,
        markPointX:0,
        markPointBalance:0,
        date: [],
        firstPointY:0,
        lastPointBalance:0,
        lastPointEquity:0
    };
    for (let j = 0; j < statistics[0].DailyRecords.length; j += stepPoints) {
        points.date.push(statistics[0].DailyRecords[j].Date);
    }
    for (let [index, [key, value]] of Object.entries(Object.entries(points.equity))) {
    getPointForOnePair(points.equity[key], statistics, index, stepPoints)
    chartObject.series[index].data = points.equity[key]
    }

    points.markPointX = points.date[points.date.length - 1]
    for (let [index, [key, value]] of Object.entries(Object.entries(points.markPoint)))
    {
    points.markPoint[key] = statistics[index].DailyRecords[statistics[index].DailyRecords.length - 1].EquityClose
    chartObject.series[index].markPoint.data[0].xAxis = points.markPointX
    chartObject.series[index].markPoint.data[0].yAxis = points.markPoint[key]
    chartObject.series[index].markPoint.data[0].value = (points.markPoint[key]).toLocaleString('ru')
    }

    chartObject.xAxis.data = points.date;


    /*points.firstPointY = statistics.DailyRecords[0].EquityClose
    points.lastPointBalance = statistics.Summary.Balance
    points.lastPointEquity = statistics.DailyRecords[statistics.DailyRecords.length - 1].EquityClose
    points.markPointEquity = statistics.DailyRecords[statistics.DailyRecords.length - 1].EquityClose
    points.markPointBalance = statistics.DailyRecords[statistics.DailyRecords.length - 1].BalanceClose
    chartObject.xAxis.data = points.date;
    chartObject.series[0].data = points.balance;
    chartObject.series[1].data = points.equity;
    chartObject.series[1].markPoint.data[0].yAxis = points.markPointEquity
    chartObject.series[1].markPoint.data[0].value = points.markPointEquity.toLocaleString('ru')
    chartObject.series[1].markPoint.data[0].xAxis = points.markPointX
    chartObject.series[0].markPoint.data[0].yAxis = points.markPointBalance
    chartObject.series[0].markPoint.data[0].value = points.markPointBalance.toLocaleString('ru')*/
    let lastpoint = 0
    if (points.lastPointEquity > points.lastPointBalance)
        lastpoint = points.lastPointEquity
    else
        lastpoint = points.lastPointBalance
    let firstLastpoints = getMaxMinPoints(points.firstPointY,lastpoint)
    //chartObject.yAxis.min = firstLastpoints.first
    //chartObject.yAxis.max = firstLastpoints.last
    //chartObject.series[0].markPoint.data[0].xAxis = points.markPointX
    }
    else {
        let pointsPair = {
        equity: [],
        markPointY: 0,
        markPointX:0,
        markPointBalance:0,
        date: [],
        firstPointY:0,
        lastPointBalance:0,
        lastPointEquity:0
        }

        for (let j = 0; j < statistics[indexPair].DailyRecords.length; j += stepPoints) {
            pointsPair.date.push(statistics[indexPair].DailyRecords[j].Date);
            pointsPair.equity.push(statistics[indexPair].DailyRecords[j].EquityClose);
        }
        chartObject.xAxis.data = pointsPair.date;
        chartObject.series[indexPair].data = pointsPair.equity;
    }
}
</script>

<style scoped>
.echarts {
  min-width: 100%;
  min-height: 100%;
}
</style>
